import VueRouter from 'vue-router';
import Applications from '../components/pages/Applications.vue';
import Dashboard from '../components/pages/Dashboard.vue';
import Login from '../components/pages/Login.vue';
import Roles from '../components/pages/Roles.vue';
import Users from '../components/pages/Users.vue';
import logout from './logout';
import successLogin from './successLogin';

export default new VueRouter({
  routes: [
    {
      path: '/',
      component: Dashboard,
    },
    {
      path: '/users',
      component: Users,
    },
    {
      path: '/roles',
      component: Roles,
    },
    {
      path: '/applications',
      component: Applications,
    },
    {
      path: '/login',
      component: Login,
    },
    {
      path: '/successLogin/:token',
      component: successLogin,
    },
    {
      path: '/errorlogin/:email',
      component: Login,
    },
    {
      path: '/logout',
      component: logout,
    },
  ],
  mode: 'history',
});
